// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationIsEmailRegisteredDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationIsEmailRegisteredDefaultResponse.attributeTypeMap;
    }
}
AuthenticationIsEmailRegisteredDefaultResponse.discriminator = undefined;
AuthenticationIsEmailRegisteredDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    }
];
//# sourceMappingURL=authenticationIsEmailRegisteredDefaultResponse.js.map